import React from 'react';
import IndustryDetail from './IndustryDetail';

const features = [
  {
    tag: 'Residential',
    title: 'Residential Projects',
    desc: 'Premium residential construction with modern design, quality materials, and on-time delivery.',
  },
  {
    tag: 'Commercial',
    title: 'Commercial Infrastructure',
    desc: 'Office buildings, commercial complexes, and retail spaces built to international standards.',
  },
  {
    tag: 'Industrial',
    title: 'Industrial Facilities',
    desc: 'Warehouses, manufacturing facilities, and industrial parks designed for operational efficiency.',
  },
  {
    tag: 'Interior',
    title: 'Interior & Fit-outs',
    desc: 'Complete interior design and fit-out services for residential and commercial spaces.',
  },
];

const Construction: React.FC = () => (
  <IndustryDetail
    breadcrumb="Construction"
    title="Ajera Builttech"
    subtitle="Innovative construction and infrastructure solutions."
    description="Ajera Builttech specializes in innovative construction solutions and high-quality infrastructure projects. From residential to commercial and industrial projects, we build with precision and purpose."
    features={features}
    accentColor="#0f766e"
  />
);

export default Construction;
